import axios from "axios";
export default async function FlightDetails() {
  // need to add ID in payload params (recheck page once)

  const options = {
    method: "GET",
    url: "https://sky-scrapper.p.rapidapi.com/api/v1/flights/getFlightDetails",
    params: {
      legs: '[{"destination":"LOND","origin":"LAXA","date":"2024-04-11"}]',
      adults: "1",
      currency: "USD",
      locale: "en-US",
      market: "en-US",
      cabinClass: "economy",
      countryCode: "US",
    },
    headers: {
      "x-rapidapi-key": process.env.REACT_APP_RAPIDAPI_KEY,
      "x-rapidapi-host":  process.env.REACT_APP_RAPIDAPI_HOST,
    },
  };

  try {
    // const response = await axios.request(options);
    const response = {
      status: true,
      timestamp: 1691009267165,
      data: {
        itinerary: {
          legs: [
            {
              id: "13542-2402201235--30598-0-12712-2402201550",
              origin: {
                id: "13542",
                name: "London Gatwick",
                displayCode: "LGW",
                city: "London",
              },
              destination: {
                id: "12712",
                name: "New York John F. Kennedy",
                displayCode: "JFK",
                city: "New York",
              },
              segments: [
                {
                  id: "13542-12712-2402201235-2402201550--30598",
                  origin: {
                    id: "13542",
                    name: "London Gatwick",
                    displayCode: "LGW",
                    city: "London",
                  },
                  destination: {
                    id: "12712",
                    name: "New York John F. Kennedy",
                    displayCode: "JFK",
                    city: "New York",
                  },
                  duration: 495,
                  dayChange: 0,
                  flightNumber: "Z0701",
                  departure: "2024-02-20T12:35:00",
                  arrival: "2024-02-20T15:50:00",
                  marketingCarrier: {
                    id: "-30598",
                    name: "Norse Atlantic Airways (UK)",
                    displayCode: "Z0",
                    displayCodeType: "IATA",
                    logo: "https://logos.skyscnr.com/images/airlines/favicon/I).png",
                    altId: "I)",
                  },
                  operatingCarrier: {
                    id: "-30598",
                    name: "Norse Atlantic Airways (UK)",
                    displayCode: "Z0",
                    displayCodeType: "IATA",
                    logo: "https://logos.skyscnr.com/images/airlines/favicon/I).png",
                    altId: "I)",
                  },
                },
              ],
              duration: 495,
              stopCount: 0,
              departure: "2024-02-20T12:35:00",
              arrival: "2024-02-20T15:50:00",
              dayChange: 0,
            },
          ],
          pricingOptions: [
            {
              agents: [
                {
                  id: "arus",
                  name: "Mytrip",
                  isCarrier: false,
                  bookingProposition: "PBOOK",
                  url: "https://www.skyscanner.net/transport_deeplink/4.0/US/en-US/USD/arus/1/13542.12712.2024-02-20/air/trava/flights?itinerary=flight|-30598|701|13542|2024-02-20T12:35|12712|2024-02-20T15:50|495|-|-|-&carriers=-30598&operators=-30598&passengers=1&channel=iphone&cabin_class=economy&fps_session_id=423a83ad-3665-45a4-b02d-d2890051d50f&ticket_price=270.99&is_npt=false&is_multipart=false&client_id=skyscanner_app&request_id=dccc6832-c515-44a9-8e9e-93a7c7b2f3b7&q_ids=H4sIAAAAAAAA_-OS4mJJLCotFmLmuKUixczRo6vQcP38OjYjJgVGAC7vlo8cAAAA|8736221224533380069|2&q_sources=JACQUARD&commercial_filters=false&q_datetime_utc=2023-08-02T20:45:04&pqid=true",
                  price: 270.99,
                  rating: {
                    value: 3.01,
                    count: 9532,
                  },
                  updateStatus: "CURRENT",
                  segments: [
                    {
                      id: "13542-12712-2402201235-2402201550--30598",
                      origin: {
                        id: "13542",
                        name: "London Gatwick",
                        displayCode: "LGW",
                        city: "London",
                      },
                      destination: {
                        id: "12712",
                        name: "New York John F. Kennedy",
                        displayCode: "JFK",
                        city: "New York",
                      },
                      duration: 495,
                      dayChange: 0,
                      flightNumber: "Z0701",
                      departure: "2024-02-20T12:35:00",
                      arrival: "2024-02-20T15:50:00",
                      marketingCarrier: {
                        id: "-30598",
                        name: "Norse Atlantic Airways (UK)",
                        displayCode: "Z0",
                        displayCodeType: "IATA",
                        logo: "https://logos.skyscnr.com/images/airlines/favicon/I).png",
                        altId: "I)",
                      },
                      operatingCarrier: {
                        id: "-30598",
                        name: "Norse Atlantic Airways (UK)",
                        displayCode: "Z0",
                        displayCodeType: "IATA",
                        logo: "https://logos.skyscnr.com/images/airlines/favicon/I).png",
                        altId: "I)",
                      },
                    },
                  ],
                  isDirectDBookUrl: false,
                  quoteAge: 3,
                },
              ],
              totalPrice: 270.99,
            },
            {
              agents: [
                {
                  id: "edus",
                  name: "eDreams",
                  isCarrier: false,
                  bookingProposition: "PBOOK",
                  url: "https://www.skyscanner.net/transport_deeplink/4.0/US/en-US/USD/edus/1/13542.12712.2024-02-20/air/trava/flights?itinerary=flight|-30598|701|13542|2024-02-20T12:35|12712|2024-02-20T15:50|495|-|-|-&carriers=-30598&operators=-30598&passengers=1&channel=iphone&cabin_class=economy&fps_session_id=423a83ad-3665-45a4-b02d-d2890051d50f&ticket_price=272.81&is_npt=false&is_multipart=false&client_id=skyscanner_app&request_id=dccc6832-c515-44a9-8e9e-93a7c7b2f3b7&q_ids=H4sIAAAAAAAA_-OS4mJJTSktFmLmuKUixczRo6vQcP38OjYjJgVGAEeFKAocAAAA|589607429926384355|2&q_sources=JACQUARD&commercial_filters=false&q_datetime_utc=2023-08-02T20:45:08&pqid=true",
                  price: 272.81,
                  rating: {
                    value: 2.63,
                    count: 10415,
                  },
                  updateStatus: "CURRENT",
                  segments: [
                    {
                      id: "13542-12712-2402201235-2402201550--30598",
                      origin: {
                        id: "13542",
                        name: "London Gatwick",
                        displayCode: "LGW",
                        city: "London",
                      },
                      destination: {
                        id: "12712",
                        name: "New York John F. Kennedy",
                        displayCode: "JFK",
                        city: "New York",
                      },
                      duration: 495,
                      dayChange: 0,
                      flightNumber: "Z0701",
                      departure: "2024-02-20T12:35:00",
                      arrival: "2024-02-20T15:50:00",
                      marketingCarrier: {
                        id: "-30598",
                        name: "Norse Atlantic Airways (UK)",
                        displayCode: "Z0",
                        displayCodeType: "IATA",
                        logo: "https://logos.skyscnr.com/images/airlines/favicon/I).png",
                        altId: "I)",
                      },
                      operatingCarrier: {
                        id: "-30598",
                        name: "Norse Atlantic Airways (UK)",
                        displayCode: "Z0",
                        displayCodeType: "IATA",
                        logo: "https://logos.skyscnr.com/images/airlines/favicon/I).png",
                        altId: "I)",
                      },
                    },
                  ],
                  isDirectDBookUrl: false,
                  quoteAge: 3,
                },
              ],
              totalPrice: 272.81,
            },
            {
              agents: [
                {
                  id: "xpus",
                  name: "Expedia",
                  isCarrier: false,
                  bookingProposition: "PBOOK",
                  url: "https://www.skyscanner.net/transport_deeplink/4.0/US/en-US/USD/xpus/1/13542.12712.2024-02-20/air/trava/flights?itinerary=flight|-30598|701|13542|2024-02-20T12:35|12712|2024-02-20T15:50|495|QEL|Q|-&carriers=-30598&operators=-30598&passengers=1&channel=iphone&cabin_class=economy&fps_session_id=423a83ad-3665-45a4-b02d-d2890051d50f&ticket_price=277.98&is_npt=false&is_multipart=false&client_id=skyscanner_app&request_id=dccc6832-c515-44a9-8e9e-93a7c7b2f3b7&q_ids=H4sIAAAAAAAA_-OS4mKpKCgtFmLmuKUixczRo6vQcP38OjYjJgVGAGMaQ04cAAAA|-2471706304482540542|2&q_sources=JACQUARD&commercial_filters=false&q_datetime_utc=2023-08-02T20:45:15&pqid=true",
                  price: 277.98,
                  rating: {
                    value: 3.96,
                    count: 12563,
                  },
                  updateStatus: "CURRENT",
                  segments: [
                    {
                      id: "13542-12712-2402201235-2402201550--30598",
                      origin: {
                        id: "13542",
                        name: "London Gatwick",
                        displayCode: "LGW",
                        city: "London",
                      },
                      destination: {
                        id: "12712",
                        name: "New York John F. Kennedy",
                        displayCode: "JFK",
                        city: "New York",
                      },
                      duration: 495,
                      dayChange: 0,
                      flightNumber: "Z0701",
                      departure: "2024-02-20T12:35:00",
                      arrival: "2024-02-20T15:50:00",
                      marketingCarrier: {
                        id: "-30598",
                        name: "Norse Atlantic Airways (UK)",
                        displayCode: "Z0",
                        displayCodeType: "IATA",
                        logo: "https://logos.skyscnr.com/images/airlines/favicon/I).png",
                        altId: "I)",
                      },
                      operatingCarrier: {
                        id: "-30598",
                        name: "Norse Atlantic Airways (UK)",
                        displayCode: "Z0",
                        displayCodeType: "IATA",
                        logo: "https://logos.skyscnr.com/images/airlines/favicon/I).png",
                        altId: "I)",
                      },
                    },
                  ],
                  isDirectDBookUrl: false,
                  quoteAge: 3,
                },
              ],
              totalPrice: 277.98,
            },
            {
              agents: [
                {
                  id: "noaa",
                  name: "Norse Atlantic Airways",
                  isCarrier: true,
                  bookingProposition: "PBOOK",
                  url: "https://www.skyscanner.net/transport_deeplink/4.0/US/en-US/USD/noaa/1/13542.12712.2024-02-20/air/airli/flights?itinerary=flight|-30598|701|13542|2024-02-20T12:35|12712|2024-02-20T15:50|495|-|-|-&carriers=-30598&operators=-30598&passengers=1&channel=iphone&cabin_class=economy&fps_session_id=423a83ad-3665-45a4-b02d-d2890051d50f&ticket_price=277.98&is_npt=false&is_multipart=false&client_id=skyscanner_app&request_id=dccc6832-c515-44a9-8e9e-93a7c7b2f3b7&q_ids=H4sIAAAAAAAA_-OS4mLJy09MFGLmeJYpxcyxIlmh4fr5dWxGTAqMAAEFxrgcAAAA|-2328735851777417191|2&q_sources=JACQUARD&commercial_filters=false&q_datetime_utc=2023-08-02T20:45:01&pqid=false",
                  price: 277.98,
                  rating: {
                    value: 3.61,
                    count: 689,
                  },
                  updateStatus: "CURRENT",
                  segments: [
                    {
                      id: "13542-12712-2402201235-2402201550--30598",
                      origin: {
                        id: "13542",
                        name: "London Gatwick",
                        displayCode: "LGW",
                        city: "London",
                      },
                      destination: {
                        id: "12712",
                        name: "New York John F. Kennedy",
                        displayCode: "JFK",
                        city: "New York",
                      },
                      duration: 495,
                      dayChange: 0,
                      flightNumber: "Z0701",
                      departure: "2024-02-20T12:35:00",
                      arrival: "2024-02-20T15:50:00",
                      marketingCarrier: {
                        id: "-30598",
                        name: "Norse Atlantic Airways (UK)",
                        displayCode: "Z0",
                        displayCodeType: "IATA",
                        logo: "https://logos.skyscnr.com/images/airlines/favicon/I).png",
                        altId: "I)",
                      },
                      operatingCarrier: {
                        id: "-30598",
                        name: "Norse Atlantic Airways (UK)",
                        displayCode: "Z0",
                        displayCodeType: "IATA",
                        logo: "https://logos.skyscnr.com/images/airlines/favicon/I).png",
                        altId: "I)",
                      },
                    },
                  ],
                  isDirectDBookUrl: false,
                  quoteAge: 3,
                },
              ],
              totalPrice: 277.98,
            },
            {
              agents: [
                {
                  id: "orbz",
                  name: "Orbitz",
                  isCarrier: false,
                  bookingProposition: "PBOOK",
                  url: "https://www.skyscanner.net/transport_deeplink/4.0/US/en-US/USD/orbz/1/13542.12712.2024-02-20/air/trava/flights?itinerary=flight|-30598|701|13542|2024-02-20T12:35|12712|2024-02-20T15:50|495|QEL|Q|-&carriers=-30598&operators=-30598&passengers=1&channel=iphone&cabin_class=economy&fps_session_id=423a83ad-3665-45a4-b02d-d2890051d50f&ticket_price=277.98&is_npt=false&is_multipart=false&client_id=skyscanner_app&request_id=dccc6832-c515-44a9-8e9e-93a7c7b2f3b7&q_ids=H4sIAAAAAAAA_-OS4mLJL0qqEmLmuKUixczRo6vQcP38OjYjJgVGACl_oJscAAAA|-2471706304482540542|2&q_sources=JACQUARD&commercial_filters=false&q_datetime_utc=2023-08-02T20:45:15&pqid=true",
                  price: 277.98,
                  rating: {
                    value: 1.89,
                    count: 1882,
                  },
                  updateStatus: "CURRENT",
                  segments: [
                    {
                      id: "13542-12712-2402201235-2402201550--30598",
                      origin: {
                        id: "13542",
                        name: "London Gatwick",
                        displayCode: "LGW",
                        city: "London",
                      },
                      destination: {
                        id: "12712",
                        name: "New York John F. Kennedy",
                        displayCode: "JFK",
                        city: "New York",
                      },
                      duration: 495,
                      dayChange: 0,
                      flightNumber: "Z0701",
                      departure: "2024-02-20T12:35:00",
                      arrival: "2024-02-20T15:50:00",
                      marketingCarrier: {
                        id: "-30598",
                        name: "Norse Atlantic Airways (UK)",
                        displayCode: "Z0",
                        displayCodeType: "IATA",
                        logo: "https://logos.skyscnr.com/images/airlines/favicon/I).png",
                        altId: "I)",
                      },
                      operatingCarrier: {
                        id: "-30598",
                        name: "Norse Atlantic Airways (UK)",
                        displayCode: "Z0",
                        displayCodeType: "IATA",
                        logo: "https://logos.skyscnr.com/images/airlines/favicon/I).png",
                        altId: "I)",
                      },
                    },
                  ],
                  isDirectDBookUrl: false,
                  quoteAge: 3,
                },
              ],
              totalPrice: 277.98,
            },
            {
              agents: [
                {
                  id: "tlcy",
                  name: "Travelocity",
                  isCarrier: false,
                  bookingProposition: "PBOOK",
                  url: "https://www.skyscanner.net/transport_deeplink/4.0/US/en-US/USD/tlcy/1/13542.12712.2024-02-20/air/trava/flights?itinerary=flight|-30598|701|13542|2024-02-20T12:35|12712|2024-02-20T15:50|495|QEL|Q|-&carriers=-30598&operators=-30598&passengers=1&channel=iphone&cabin_class=economy&fps_session_id=423a83ad-3665-45a4-b02d-d2890051d50f&ticket_price=277.98&is_npt=false&is_multipart=false&client_id=skyscanner_app&request_id=dccc6832-c515-44a9-8e9e-93a7c7b2f3b7&q_ids=H4sIAAAAAAAA_-OS4mIpyUmuFGLmuKUixczRo6vQcP38OjYjJgVGALHE7-4cAAAA|-2471706304482540542|2&q_sources=JACQUARD&commercial_filters=false&q_datetime_utc=2023-08-02T20:45:17&pqid=true",
                  price: 277.98,
                  rating: {
                    value: 1.67,
                    count: 467,
                  },
                  updateStatus: "CURRENT",
                  segments: [
                    {
                      id: "13542-12712-2402201235-2402201550--30598",
                      origin: {
                        id: "13542",
                        name: "London Gatwick",
                        displayCode: "LGW",
                        city: "London",
                      },
                      destination: {
                        id: "12712",
                        name: "New York John F. Kennedy",
                        displayCode: "JFK",
                        city: "New York",
                      },
                      duration: 495,
                      dayChange: 0,
                      flightNumber: "Z0701",
                      departure: "2024-02-20T12:35:00",
                      arrival: "2024-02-20T15:50:00",
                      marketingCarrier: {
                        id: "-30598",
                        name: "Norse Atlantic Airways (UK)",
                        displayCode: "Z0",
                        displayCodeType: "IATA",
                        logo: "https://logos.skyscnr.com/images/airlines/favicon/I).png",
                        altId: "I)",
                      },
                      operatingCarrier: {
                        id: "-30598",
                        name: "Norse Atlantic Airways (UK)",
                        displayCode: "Z0",
                        displayCodeType: "IATA",
                        logo: "https://logos.skyscnr.com/images/airlines/favicon/I).png",
                        altId: "I)",
                      },
                    },
                  ],
                  isDirectDBookUrl: false,
                  quoteAge: 3,
                },
              ],
              totalPrice: 277.98,
            },
            {
              agents: [
                {
                  id: "skyp",
                  name: "Kiwi.com",
                  isCarrier: false,
                  bookingProposition: "PBOOK",
                  url: "https://www.skyscanner.net/transport_deeplink/4.0/US/en-US/USD/skyp/1/13542.12712.2024-02-20/air/trava/flights?itinerary=flight|-30598|701|13542|2024-02-20T12:35|12712|2024-02-20T15:50|495|-|-|-&carriers=-30598&operators=-30598&passengers=1&channel=iphone&cabin_class=economy&fps_session_id=423a83ad-3665-45a4-b02d-d2890051d50f&ticket_price=280.00&is_npt=false&is_multipart=false&client_id=skyscanner_app&request_id=dccc6832-c515-44a9-8e9e-93a7c7b2f3b7&q_ids=H4sIAAAAAAAA_-OS4mIpzq4sEGLmuKUixczRo6vQcP38OjYjJgVGAEFEgi0cAAAA|-2328735851777417191|2&q_sources=JACQUARD&commercial_filters=false&q_datetime_utc=2023-08-02T20:45:09&pqid=true",
                  price: 280,
                  rating: {
                    value: 2.92,
                    count: 12352,
                  },
                  updateStatus: "CURRENT",
                  segments: [
                    {
                      id: "13542-12712-2402201235-2402201550--30598",
                      origin: {
                        id: "13542",
                        name: "London Gatwick",
                        displayCode: "LGW",
                        city: "London",
                      },
                      destination: {
                        id: "12712",
                        name: "New York John F. Kennedy",
                        displayCode: "JFK",
                        city: "New York",
                      },
                      duration: 495,
                      dayChange: 0,
                      flightNumber: "Z0701",
                      departure: "2024-02-20T12:35:00",
                      arrival: "2024-02-20T15:50:00",
                      marketingCarrier: {
                        id: "-30598",
                        name: "Norse Atlantic Airways (UK)",
                        displayCode: "Z0",
                        displayCodeType: "IATA",
                        logo: "https://logos.skyscnr.com/images/airlines/favicon/I).png",
                        altId: "I)",
                      },
                      operatingCarrier: {
                        id: "-30598",
                        name: "Norse Atlantic Airways (UK)",
                        displayCode: "Z0",
                        displayCodeType: "IATA",
                        logo: "https://logos.skyscnr.com/images/airlines/favicon/I).png",
                        altId: "I)",
                      },
                    },
                  ],
                  isDirectDBookUrl: false,
                  quoteAge: 3,
                },
              ],
              totalPrice: 280,
            },
            {
              agents: [
                {
                  id: "pcln",
                  name: "Priceline",
                  isCarrier: false,
                  bookingProposition: "PBOOK",
                  url: "https://www.skyscanner.net/transport_deeplink/4.0/US/en-US/USD/pcln/1/13542.12712.2024-02-20/air/trava/flights?itinerary=flight|-30598|701|13542|2024-02-20T12:35|12712|2024-02-20T15:50|495|QEL|Q|-&carriers=-30598&operators=-30598&passengers=1&channel=iphone&cabin_class=economy&fps_session_id=423a83ad-3665-45a4-b02d-d2890051d50f&ticket_price=279.08&is_npt=false&is_multipart=false&client_id=skyscanner_app&request_id=dccc6832-c515-44a9-8e9e-93a7c7b2f3b7&q_ids=H4sIAAAAAAAA_-OS4mIpSM7JE2LmuKUixczRo6vQcP38OjYjJgVGAJINcA8cAAAA|836989890372451239|2&q_sources=JACQUARD&commercial_filters=false&q_datetime_utc=2023-08-02T20:45:04&pqid=false",
                  price: 279.08,
                  rating: {
                    value: 1.87,
                    count: 2029,
                  },
                  updateStatus: "CURRENT",
                  segments: [
                    {
                      id: "13542-12712-2402201235-2402201550--30598",
                      origin: {
                        id: "13542",
                        name: "London Gatwick",
                        displayCode: "LGW",
                        city: "London",
                      },
                      destination: {
                        id: "12712",
                        name: "New York John F. Kennedy",
                        displayCode: "JFK",
                        city: "New York",
                      },
                      duration: 495,
                      dayChange: 0,
                      flightNumber: "Z0701",
                      departure: "2024-02-20T12:35:00",
                      arrival: "2024-02-20T15:50:00",
                      marketingCarrier: {
                        id: "-30598",
                        name: "Norse Atlantic Airways (UK)",
                        displayCode: "Z0",
                        displayCodeType: "IATA",
                        logo: "https://logos.skyscnr.com/images/airlines/favicon/I).png",
                        altId: "I)",
                      },
                      operatingCarrier: {
                        id: "-30598",
                        name: "Norse Atlantic Airways (UK)",
                        displayCode: "Z0",
                        displayCodeType: "IATA",
                        logo: "https://logos.skyscnr.com/images/airlines/favicon/I).png",
                        altId: "I)",
                      },
                    },
                  ],
                  isDirectDBookUrl: false,
                  quoteAge: 3,
                },
              ],
              totalPrice: 279.08,
            },
            {
              agents: [
                {
                  id: "cust",
                  name: "Trip.com",
                  isCarrier: false,
                  bookingProposition: "PBOOK",
                  url: "https://www.skyscanner.net/transport_deeplink/4.0/US/en-US/USD/cust/1/13542.12712.2024-02-20/air/trava/flights?itinerary=flight|-30598|701|13542|2024-02-20T12:35|12712|2024-02-20T15:50|495|-|-|-&carriers=-30598&operators=-30598&passengers=1&channel=iphone&cabin_class=economy&fps_session_id=423a83ad-3665-45a4-b02d-d2890051d50f&ticket_price=282.00&is_npt=false&is_multipart=false&client_id=skyscanner_app&request_id=dccc6832-c515-44a9-8e9e-93a7c7b2f3b7&q_ids=H4sIAAAAAAAA_-OS4mJJLi0uEWLmuKUixczRo6vQcP38OjYjJgVGAFdnAjscAAAA|-1392380853158557016|2&q_sources=JACQUARD&commercial_filters=false&q_datetime_utc=2023-08-02T20:45:08&pqid=true",
                  price: 282,
                  rating: {
                    value: 3.67,
                    count: 30283,
                  },
                  updateStatus: "CURRENT",
                  segments: [
                    {
                      id: "13542-12712-2402201235-2402201550--30598",
                      origin: {
                        id: "13542",
                        name: "London Gatwick",
                        displayCode: "LGW",
                        city: "London",
                      },
                      destination: {
                        id: "12712",
                        name: "New York John F. Kennedy",
                        displayCode: "JFK",
                        city: "New York",
                      },
                      duration: 495,
                      dayChange: 0,
                      flightNumber: "Z0701",
                      departure: "2024-02-20T12:35:00",
                      arrival: "2024-02-20T15:50:00",
                      marketingCarrier: {
                        id: "-30598",
                        name: "Norse Atlantic Airways (UK)",
                        displayCode: "Z0",
                        displayCodeType: "IATA",
                        logo: "https://logos.skyscnr.com/images/airlines/favicon/I).png",
                        altId: "I)",
                      },
                      operatingCarrier: {
                        id: "-30598",
                        name: "Norse Atlantic Airways (UK)",
                        displayCode: "Z0",
                        displayCodeType: "IATA",
                        logo: "https://logos.skyscnr.com/images/airlines/favicon/I).png",
                        altId: "I)",
                      },
                    },
                  ],
                  isDirectDBookUrl: false,
                  quoteAge: 3,
                },
              ],
              totalPrice: 282,
            },
            {
              agents: [
                {
                  id: "jfus",
                  name: "JustFly",
                  isCarrier: false,
                  bookingProposition: "PBOOK",
                  url: "https://www.skyscanner.net/transport_deeplink/4.0/US/en-US/USD/jfus/1/13542.12712.2024-02-20/air/trava/flights?itinerary=flight|-30598|701|13542|2024-02-20T12:35|12712|2024-02-20T15:50|495|QEL|Q|-&carriers=-30598&operators=-30598&passengers=1&channel=iphone&cabin_class=economy&fps_session_id=423a83ad-3665-45a4-b02d-d2890051d50f&ticket_price=282.98&is_npt=false&is_multipart=false&client_id=skyscanner_app&request_id=dccc6832-c515-44a9-8e9e-93a7c7b2f3b7&q_ids=H4sIAAAAAAAA_-OS4mLJSistFmLmuKUixczRo6vQcP38OjYjJgVGAGddqwQcAAAA|836989890372451239|2&q_sources=JACQUARD&commercial_filters=false&q_datetime_utc=2023-08-02T20:45:06&pqid=false",
                  price: 282.98,
                  rating: {
                    value: 3.38,
                    count: 6951,
                  },
                  updateStatus: "CURRENT",
                  segments: [
                    {
                      id: "13542-12712-2402201235-2402201550--30598",
                      origin: {
                        id: "13542",
                        name: "London Gatwick",
                        displayCode: "LGW",
                        city: "London",
                      },
                      destination: {
                        id: "12712",
                        name: "New York John F. Kennedy",
                        displayCode: "JFK",
                        city: "New York",
                      },
                      duration: 495,
                      dayChange: 0,
                      flightNumber: "Z0701",
                      departure: "2024-02-20T12:35:00",
                      arrival: "2024-02-20T15:50:00",
                      marketingCarrier: {
                        id: "-30598",
                        name: "Norse Atlantic Airways (UK)",
                        displayCode: "Z0",
                        displayCodeType: "IATA",
                        logo: "https://logos.skyscnr.com/images/airlines/favicon/I).png",
                        altId: "I)",
                      },
                      operatingCarrier: {
                        id: "-30598",
                        name: "Norse Atlantic Airways (UK)",
                        displayCode: "Z0",
                        displayCodeType: "IATA",
                        logo: "https://logos.skyscnr.com/images/airlines/favicon/I).png",
                        altId: "I)",
                      },
                    },
                  ],
                  isDirectDBookUrl: false,
                  quoteAge: 3,
                },
              ],
              totalPrice: 282.98,
            },
            {
              agents: [
                {
                  id: "chpo",
                  name: "CheapOair",
                  isCarrier: false,
                  bookingProposition: "PBOOK",
                  url: "https://www.skyscanner.net/transport_deeplink/4.0/US/en-US/USD/chpo/1/13542.12712.2024-02-20/air/trava/flights?itinerary=flight|-30598|701|13542|2024-02-20T12:35|12712|2024-02-20T15:50|495|-|-|-&carriers=-30598&operators=-30598&passengers=1&channel=iphone&cabin_class=economy&fps_session_id=423a83ad-3665-45a4-b02d-d2890051d50f&ticket_price=283.98&is_npt=false&is_multipart=false&client_id=skyscanner_app&request_id=dccc6832-c515-44a9-8e9e-93a7c7b2f3b7&q_ids=H4sIAAAAAAAA_-OS4mJJzijIF2LmuKUixczRo6vQcP38OjYjJgVGAEPdlo0cAAAA|-2328735851777417191|2&q_sources=JACQUARD&commercial_filters=false&q_datetime_utc=2023-08-02T20:45:11&pqid=false",
                  price: 283.98,
                  rating: {
                    value: 2.57,
                    count: 3276,
                  },
                  updateStatus: "CURRENT",
                  segments: [
                    {
                      id: "13542-12712-2402201235-2402201550--30598",
                      origin: {
                        id: "13542",
                        name: "London Gatwick",
                        displayCode: "LGW",
                        city: "London",
                      },
                      destination: {
                        id: "12712",
                        name: "New York John F. Kennedy",
                        displayCode: "JFK",
                        city: "New York",
                      },
                      duration: 495,
                      dayChange: 0,
                      flightNumber: "Z0701",
                      departure: "2024-02-20T12:35:00",
                      arrival: "2024-02-20T15:50:00",
                      marketingCarrier: {
                        id: "-30598",
                        name: "Norse Atlantic Airways (UK)",
                        displayCode: "Z0",
                        displayCodeType: "IATA",
                        logo: "https://logos.skyscnr.com/images/airlines/favicon/I).png",
                        altId: "I)",
                      },
                      operatingCarrier: {
                        id: "-30598",
                        name: "Norse Atlantic Airways (UK)",
                        displayCode: "Z0",
                        displayCodeType: "IATA",
                        logo: "https://logos.skyscnr.com/images/airlines/favicon/I).png",
                        altId: "I)",
                      },
                    },
                  ],
                  isDirectDBookUrl: false,
                  quoteAge: 3,
                },
              ],
              totalPrice: 283.98,
            },
            {
              agents: [
                {
                  id: "bcom",
                  name: "Booking.com",
                  isCarrier: false,
                  bookingProposition: "PBOOK",
                  url: "https://www.skyscanner.net/transport_deeplink/4.0/US/en-US/USD/bcom/1/13542.12712.2024-02-20/air/trava/flights?itinerary=flight|-30598|701|13542|2024-02-20T12:35|12712|2024-02-20T15:50|495|-|-|-&carriers=-30598&operators=-30598&passengers=1&channel=iphone&cabin_class=economy&fps_session_id=423a83ad-3665-45a4-b02d-d2890051d50f&ticket_price=285.99&is_npt=false&is_multipart=false&client_id=skyscanner_app&request_id=dccc6832-c515-44a9-8e9e-93a7c7b2f3b7&q_ids=H4sIAAAAAAAA_-OS4mJJSs7PFWLmuKUixczRo6vQcP38OjYjJgVGAAORRuscAAAA|3610398678000586459|2&q_sources=JACQUARD&commercial_filters=false&q_datetime_utc=2023-08-02T20:45:04&pqid=true",
                  price: 285.99,
                  rating: {
                    value: 3.63,
                    count: 7583,
                  },
                  updateStatus: "CURRENT",
                  segments: [
                    {
                      id: "13542-12712-2402201235-2402201550--30598",
                      origin: {
                        id: "13542",
                        name: "London Gatwick",
                        displayCode: "LGW",
                        city: "London",
                      },
                      destination: {
                        id: "12712",
                        name: "New York John F. Kennedy",
                        displayCode: "JFK",
                        city: "New York",
                      },
                      duration: 495,
                      dayChange: 0,
                      flightNumber: "Z0701",
                      departure: "2024-02-20T12:35:00",
                      arrival: "2024-02-20T15:50:00",
                      marketingCarrier: {
                        id: "-30598",
                        name: "Norse Atlantic Airways (UK)",
                        displayCode: "Z0",
                        displayCodeType: "IATA",
                        logo: "https://logos.skyscnr.com/images/airlines/favicon/I).png",
                        altId: "I)",
                      },
                      operatingCarrier: {
                        id: "-30598",
                        name: "Norse Atlantic Airways (UK)",
                        displayCode: "Z0",
                        displayCodeType: "IATA",
                        logo: "https://logos.skyscnr.com/images/airlines/favicon/I).png",
                        altId: "I)",
                      },
                    },
                  ],
                  isDirectDBookUrl: false,
                  quoteAge: 3,
                },
              ],
              totalPrice: 285.99,
            },
            {
              agents: [
                {
                  id: "vaya",
                  name: "BudgetAir",
                  isCarrier: false,
                  bookingProposition: "PBOOK",
                  url: "https://www.skyscanner.net/transport_deeplink/4.0/US/en-US/USD/vaya/1/13542.12712.2024-02-20/air/trava/flights?itinerary=flight|-30598|701|13542|2024-02-20T12:35|12712|2024-02-20T15:50|495|-|-|-&carriers=-30598&operators=-30598&passengers=1&channel=iphone&cabin_class=economy&fps_session_id=423a83ad-3665-45a4-b02d-d2890051d50f&ticket_price=286.00&is_npt=false&is_multipart=false&client_id=skyscanner_app&request_id=dccc6832-c515-44a9-8e9e-93a7c7b2f3b7&q_ids=H4sIAAAAAAAA_-OS4mIpS6xMFGLmuKUixczRo6vQcP38OjYjJgVGAIS-sPwcAAAA|589607429926384355|2&q_sources=JACQUARD&commercial_filters=false&q_datetime_utc=2023-08-02T20:45:16&pqid=true",
                  price: 286,
                  rating: {
                    value: 2.85,
                    count: 5155,
                  },
                  updateStatus: "CURRENT",
                  segments: [
                    {
                      id: "13542-12712-2402201235-2402201550--30598",
                      origin: {
                        id: "13542",
                        name: "London Gatwick",
                        displayCode: "LGW",
                        city: "London",
                      },
                      destination: {
                        id: "12712",
                        name: "New York John F. Kennedy",
                        displayCode: "JFK",
                        city: "New York",
                      },
                      duration: 495,
                      dayChange: 0,
                      flightNumber: "Z0701",
                      departure: "2024-02-20T12:35:00",
                      arrival: "2024-02-20T15:50:00",
                      marketingCarrier: {
                        id: "-30598",
                        name: "Norse Atlantic Airways (UK)",
                        displayCode: "Z0",
                        displayCodeType: "IATA",
                        logo: "https://logos.skyscnr.com/images/airlines/favicon/I).png",
                        altId: "I)",
                      },
                      operatingCarrier: {
                        id: "-30598",
                        name: "Norse Atlantic Airways (UK)",
                        displayCode: "Z0",
                        displayCodeType: "IATA",
                        logo: "https://logos.skyscnr.com/images/airlines/favicon/I).png",
                        altId: "I)",
                      },
                    },
                  ],
                  isDirectDBookUrl: false,
                  quoteAge: 3,
                },
              ],
              totalPrice: 286,
            },
            {
              agents: [
                {
                  id: "bfus",
                  name: "Bravofly",
                  isCarrier: false,
                  bookingProposition: "PBOOK",
                  url: "https://www.skyscanner.net/transport_deeplink/4.0/US/en-US/USD/bfus/1/13542.12712.2024-02-20/air/trava/flights?itinerary=flight|-30598|701|13542|2024-02-20T12:35|12712|2024-02-20T15:50|495|-|Q|-&carriers=-30598&operators=-30598&passengers=1&channel=iphone&cabin_class=economy&fps_session_id=423a83ad-3665-45a4-b02d-d2890051d50f&ticket_price=287.37&is_npt=false&is_multipart=false&client_id=skyscanner_app&request_id=dccc6832-c515-44a9-8e9e-93a7c7b2f3b7&q_ids=H4sIAAAAAAAA_-OS4mJJSistFmLmuKUixczRo6vQcP38OjYjJgVGANlhptYcAAAA|-6737075005787650101|2&q_sources=JACQUARD&commercial_filters=false&q_datetime_utc=2023-08-02T20:45:02&pqid=true",
                  price: 287.37,
                  rating: {
                    value: 2.69,
                    count: 2763,
                  },
                  updateStatus: "CURRENT",
                  segments: [
                    {
                      id: "13542-12712-2402201235-2402201550--30598",
                      origin: {
                        id: "13542",
                        name: "London Gatwick",
                        displayCode: "LGW",
                        city: "London",
                      },
                      destination: {
                        id: "12712",
                        name: "New York John F. Kennedy",
                        displayCode: "JFK",
                        city: "New York",
                      },
                      duration: 495,
                      dayChange: 0,
                      flightNumber: "Z0701",
                      departure: "2024-02-20T12:35:00",
                      arrival: "2024-02-20T15:50:00",
                      marketingCarrier: {
                        id: "-30598",
                        name: "Norse Atlantic Airways (UK)",
                        displayCode: "Z0",
                        displayCodeType: "IATA",
                        logo: "https://logos.skyscnr.com/images/airlines/favicon/I).png",
                        altId: "I)",
                      },
                      operatingCarrier: {
                        id: "-30598",
                        name: "Norse Atlantic Airways (UK)",
                        displayCode: "Z0",
                        displayCodeType: "IATA",
                        logo: "https://logos.skyscnr.com/images/airlines/favicon/I).png",
                        altId: "I)",
                      },
                    },
                  ],
                  isDirectDBookUrl: false,
                  quoteAge: 3,
                },
              ],
              totalPrice: 287.37,
            },
          ],
          isTransferRequired: false,
          destinationImage:
            "https://content.skyscnr.com/b62fd4346123d1eb9f7525c8f72f2a8a/stock-photo-new-york-city-at-twilight-128894587.jpg",
          operatingCarrierSafetyAttributes: [
            {
              carrierID: "-30598",
              carrierName: "Norse Atlantic Airways (UK)",
              faceMasksCompulsory: null,
              aircraftDeepCleanedDaily: null,
              attendantsWearPPE: null,
              cleaningPacksProvided: null,
              foodServiceChanges: null,
              safetyUrl: null,
            },
          ],
          flexibleTicketPolicies: [],
        },
        pollingCompleted: true,
      },
    };
    return response.data;
  } catch (error) {
    console.error(error);
  }
}
